import { useState } from 'react';
import { Copy } from 'lucide-react';

export function ClipboardButton({ value }: { value: string }) {
	const [copied, setCopied] = useState(false);

	const handleClick = async () => {
		try {
			await navigator.clipboard.writeText(value);
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		} catch (err) {
			console.error('Failed to copy!', err);
		}
	};

	return (
		<button
			onClick={handleClick}
			className="group relative rounded-md bg-gray-200 p-1 shadow-sm transition-all hover:bg-gray-300 active:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-900 dark:active:bg-gray-700"
		>
			<Copy className="pointer-events-none size-3 group-active:scale-95" />
			<span className="pointer-events-none absolute -top-1 left-1/2 block -translate-x-1/2 -translate-y-full whitespace-nowrap rounded-md border border-black bg-black/75 p-2 text-[10px] leading-none text-gray-200 opacity-0 shadow-md backdrop-blur-sm transition-opacity group-hover:opacity-100 dark:border-gray-500 dark:bg-gray-50/75 dark:text-gray-900">
				{copied ? 'Copied!' : 'Copy to clipboard'}
			</span>
		</button>
	);
}
